import {
  AddProfileIcon,
  CalenderIcon,
  ChatIcon,
  CopyEmailIcon,
  DocIcon,
  DocIconNew,
  EmailIcon,
  EyeIcon,
  LikeIconFilled,
  MouseIcon,
  OfferIcon,
  ProfileIcon,
  SendIcon,
  ShareIconNew,
  SignOutIconNew,
  StopIcon
} from '@/src/assets/icons'
import dayjs from 'dayjs'
import { ReactNode } from 'react'

export const getPercentage = (a: number, b: number) => {
  if (b == 0) return 0
  const per = (a / b) * 100
  return per.toFixed(0)
}

export const getDaysNo = (date: string) => {
  const startDate = dayjs(date)
  const endDate = dayjs() // Today's date

  const numberOfDays = endDate.diff(startDate, 'day')
  return numberOfDays
}

export interface tabTypes {
  name: string
  id: string
}

export interface tabBarTypes {
  name: string
  icon: string
}

export const sideTab: tabTypes[] = [
  { name: 'Site', id: 'Site' },
  { name: 'Investors', id: 'Investors' },
  { name: 'Content', id: 'Content' },
  { name: 'Questions', id: 'Questions' },
  { name: 'Email Broadcasts', id: 'EmailBroadcasts' },
  { name: 'Investor Engagement', id: 'InvestorEngagement' }
  // { name: "Holding Reports", id: "HoldingReports" },
]

export const dashboardTabBar: tabBarTypes[] = [
  { name: 'Activity', icon: '' },
  { name: 'Performance', icon: '' },
  { name: 'Distribution', icon: '' },
  { name: 'Engagement', icon: '' }
]

export function formatNumber(number: number | string, newTheme: boolean = false) {
  if (+number >= 999999999999) {
    return (
      (+number / 999999999999).toFixed(+number / 999999999999 <= 0.1 ? 3 : newTheme ? 3 : 2) + 'T'
    )
  } else if (+number >= 999999999) {
    return (+number / 999999999).toFixed(+number / 999999999 <= 0.1 ? 3 : newTheme ? 3 : 2) + 'B'
  } else if (+number >= 1000000) {
    return (+number / 1000000).toFixed(+number / 1000000 <= 0.1 ? 3 : newTheme ? 3 : 2) + 'M'
  } else if (+number >= 1000) {
    return (+number / 1000).toFixed(+number / 1000 <= 0.1 ? 3 : newTheme ? 3 : 1) + 'K'
  } else {
    return typeof number === 'string'
      ? parseInt(number).toFixed(3)
      : number?.toFixed(number <= 0.1 ? 3 : newTheme ? 3 : 2)
  }
}

export function formatNumberNoDec(number: number | string) {
  if (+number >= 1000000) {
    return +number / 1000000 + 'M'
  } else if (+number >= 1000) {
    return +number / 1000 + 'k'
  } else {
    return number
  }
}

interface siteFiltersTypes {
  name: string
  value: string
  id: string
}

export interface cardProps {
  title: string
  count: string
  percentage?: string
  icon: React.ReactNode
  bg: string
  footer?: string
  loading?: boolean
}

export interface dashboardCardProps {
  name: string
  desc: string | ReactNode
  count?: number
  percentage?: number
  ringCount?: number
  current_count?: number
  ringColor?: string
  type?: string
  botttomText?: string
  loading?: boolean
  invertColor?: boolean
  hidden?: boolean
  tileName?: string
}

export const siteFilters: siteFiltersTypes[] = [
  {
    name: 'Past 7 days',
    value: 'past_7_days',
    id: 'past_7_days'
  },
  {
    name: 'Past 30 days',
    value: 'past_30_days',
    id: 'past_30_days'
  },
  {
    name: 'Past 90 days',
    value: 'past_90_days',
    id: 'past_90_days'
  },
  {
    name: 'Past year',
    value: 'past_year',
    id: 'past_year'
  }
]

export const getSiteCards = (data: any) => [
  {
    title: 'Site visits',
    count: data.site_vist,
    icon: <EyeIcon className="w-[18.67px] h-[18.67px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]'
  },
  {
    title: 'Unique visits',
    count: data.unique_visit,
    icon: <ProfileIcon className="w-[18.67px] h-[18.67px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]'
  },
  {
    title: 'Log ins',
    count: data.logins,
    icon: <SignOutIconNew className="w-[18.67px] h-[18.67px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]'
  },
  {
    title: 'Avg. pages per visit',
    count: data.average_page_visit,
    icon: <DocIconNew className="w-[18.67px] h-[18.67px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]'
  }
]

export const getInvestorCardData = (data: any) => [
  {
    title: 'New users',
    count: data.new_users,
    icon: <AddProfileIcon className="w-[26.4px] h-[19.2px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]',
    percentage: `+ ${getPercentage(data.new_users, data.total_users)}%`
  },
  {
    title: 'Active users',
    count: data.active_users,
    icon: <OfferIcon className="w-[26.4px] h-[25.12px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]',
    percentage: `${getPercentage(data.active_users, data.total_users)}%`
  },
  {
    title: 'Deactivated accounts',
    count: data.deleted_users,
    icon: <StopIcon className="w-6 h-6 fill-error-red" />,
    bg: 'bg-[#D32F2F14]',
    percentage: `${getPercentage(data.deleted_users, data.total_users)}%`
  }
]

export const getcontentCards = (data: any, main: boolean) => [
  {
    title: main ? 'Posts' : 'Posted',
    count: main ? data.total_content : getDaysNo(data.last_publish),
    icon: main ? (
      <DocIcon className="w-[21.6px] h-[21.6px] fill-success-main" />
    ) : (
      <CalenderIcon className="w-[24px] h-[26.4px] fill-success-main" />
    ),
    bg: 'bg-[#2E7D3214]',
    percentage: main ? ' ' : 'days'
  },
  {
    title: 'Views',
    count: data.total_view,
    icon: <EyeIcon className="w-[24.6px] h-[18px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]'
  },
  {
    title: 'Questions',
    count: data.total_questions,
    icon: <ChatIcon className="w-[23.3px] h-[23.3px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]'
  },
  {
    title: 'Likes',
    count: data.total_like,
    icon: <LikeIconFilled className="w-[25.67px] h-[23.33px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]'
  },
  {
    title: 'Shares',
    count: data.total_share,
    icon: <ShareIconNew className="w-[27.75px] h-[23.13px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]'
  }
]
export const getEmailCards = (data: any, main: boolean) => [
  {
    title: main ? 'Emails sent' : 'Sent',
    count: main ? data.email_sent : getDaysNo(data.send_date),
    icon: main ? (
      <EmailIcon className="w-[21.6px] h-[21.6px] fill-success-main" />
    ) : (
      <CalenderIcon className="w-[24px] h-[26.4px] fill-success-main" />
    ),
    bg: 'bg-[#2E7D3214]',
    percentage: main ? ' ' : 'days ago'
  },
  {
    title: 'Delivered',
    count: data.delivered,
    icon: <SendIcon className="w-[25.2px] h-[21.6px] fill-success-main -rotate-5 -mt-1 ml-1" />,
    bg: 'bg-[#2E7D3214]',
    percentage: `${data.bounced} bounced`
  },
  {
    title: 'Opened',
    count: data.opened,
    icon: <CopyEmailIcon className="w-[24.3px] h-[22.8px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]',
    percentage: `${getPercentage(data.opened, data.delivered)}%`
  },
  {
    title: 'Clicked',
    count: data.clicked,
    icon: <MouseIcon className="w-[19.2px] h-[26.32px] fill-success-main" />,
    bg: 'bg-[#2E7D3214]',
    percentage: `${getPercentage(data.clicked, data.delivered)}%`
  },
  {
    title: 'Unsubscribed',
    count: data.unsubscribe,
    icon: <StopIcon className="w-6 h-6 fill-error-red" />,
    bg: 'bg-[#D32F2F14]',
    percentage: `${getPercentage(data.unsubscribe, data.delivered)}%`
  }
]

export const generateHolderCsv = (data: any) => {
  const holdingReport = [['Holder Names', 'Holding', 'Holder Number', 'Position']]
  for (let i = 0; i < data.length; i++) {
    const newArr = []
    newArr.push(data[i].holderNames)
    newArr.push(data[i].holding)
    newArr.push(data[i].holderNumber)
    newArr.push(data[i].position)
    holdingReport.push(newArr)
  }
  return holdingReport
}

export const generateTransactionCsv = (data: any) => {
  const holdingReport = [
    [
      'Account Holders',
      'Movement Type',
      'Closing Balance',
      'Movement',
      'Broker Name',
      'Created Date'
    ]
  ]
  for (let i = 0; i < data.length; i++) {
    const newArr = []
    newArr.push(data[i].accountHolders)
    newArr.push(data[i].movementType)
    newArr.push(data[i].closingBalance)
    newArr.push(data[i].movement)
    newArr.push(data[i].brokerName)
    newArr.push(data[i].createdDate)
    holdingReport.push(newArr)
  }
  return holdingReport
}

export const shareholderLabels = {
  graph: [
    { name: 'Exited sellers', color: 'bg-[#E2AEAE]' },
    { name: 'Partial sellers', color: 'bg-[#F8DEDE]' },
    { name: 'New buyers', color: 'bg-[#9CC4A3]' },
    { name: 'Returning buyers', color: 'bg-[#CFE2D2]' },
    { name: 'Existing buyers', color: 'bg-[#EEF5EF]' }
  ],
  pieChart1: [
    { name: 'New', color: 'bg-[#2E7D32]' },
    { name: 'Returning', color: 'bg-[#A9C9AC]' },
    { name: 'Existing', color: 'bg-[#DEEAE0]' }
  ],
  pieChart2: [
    { name: 'Exited', color: 'bg-[#D32F2F]' },
    { name: 'Partial', color: 'bg-[#F2C1C1]' }
  ],
  tableLabels: [
    { name: 'New', bg: 'bg-[#2E7D32]', color: '#ffffff' },
    { name: 'Returning', bg: 'bg-[#A9C9AC]', color: 'text.primary' },
    { name: 'Existing', bg: 'bg-[#DEEAE0]', color: 'text.primary' },
    { name: 'Exited', bg: 'bg-[#D32F2F]', color: '#ffffff' },
    { name: 'Partial', bg: 'bg-[#F2C1C1]', color: 'text.primary' }
  ]
}

export const ShareholderCards = (data: any) => [
  {
    name: 'Buyers',
    desc: (
      <>
        Number of shareholders who bought shares during this period.
        <br />
        The change shown is relative to the previous period.
      </>
    ),
    count: data?.buyers,
    percentage: data?.buyers_percentage
  },
  {
    name: 'Sellers',
    desc: (
      <>
        Number of shareholders who sold shares during this period.
        <br />
        The change shown is relative to the previous period.
      </>
    ),
    count: data?.sellers,
    percentage: data?.sellers_percentage,
    invertColor: true
  }
]

export const PerformanceCards = (data: any) => [
  {
    name: 'In the money',
    desc: (
      <>
        Number of shareholders who are in the money (had positive returns) as of today.
        <br />
        The percentage shown is relative to the total shareholders.
      </>
    ),
    count: data?.in_money_count,
    percentage: data?.in_money_percentage,
    ringColor: '#2E7D32'
  },
  {
    name: 'Underwater',
    desc: (
      <>
        Number of shareholders who are underwater (had negative returns) as of today.
        <br />
        The percentage shown is relative to the total shareholders.
      </>
    ),
    count: data?.underwater_count,
    percentage: data?.underwater_percentage,
    ringColor: '#D32F2F'
  }
]

export const DistributionCards = (data: any) => [
  {
    name: 'Total contacts',
    desc: (
      <>
        Number of all shareholders (both current and ex-shareholders) as well as all users
        (Investors and regular users) as of today. <br />
        The change shown is relative to 30 days ago.
      </>
    ),
    count: data?.total_contacts,
    current_count: data?.current_total_contacts,
    percentage: data?.current_total_contact_percentage,
    botttomText: 'Last 30 days'
  },
  {
    name: 'Total shareholders',
    desc: (
      <>
        Number of current shareholders (does not include ex-shareholders) as of today.
        <br /> The change shown is relative to 30 days ago.
      </>
    ),
    count: data?.total_shareholders,
    current_count: data?.current_total_shareholders,
    percentage: data?.current_total_shareholders_percentage,
    botttomText: 'Last 30 days'
  },
  {
    name: 'Contactable shareholders',
    desc: (
      <>
        Number of current shareholders (does not include ex-shareholders) who have an email address
        as of today (does not include those who have suppressed or unsubscribed).
        <br /> The change shown is relative to 30 days ago.
      </>
    ),
    count: data?.contactable_shareholders,
    current_count: data?.current_c_shareholders,
    percentage: data?.current_c_shareholders_percentage,
    botttomText: 'Last 30 days',
    ringCount: data?.contactable_holders_percentage,
    ringColor: '#2E7D32'
  },
  {
    name: 'Top 20 holders concentration',
    desc: <>% of Shares on Issue held by the top 20 Holder accounts as of today.</>,
    count: data?.top_20_holder_concentration,
    type: 'percent'
  },
  {
    name: 'Unmarketable shares',
    desc: (
      <>
        An unmarketable parcel is a shareholding whose market value is less than AUD $500 based on
        the share price at a specific record date.
      </>
    ),
    count: data?.unmarketable_shares,
    ringCount: data?.unmarketable_shares_pct,
    ringColor: '#2E7D32'
  },
  {
    name: 'Shareholders w/unmarketable parcel',
    desc: (
      <>
        Number of shareholders whose holdings are valued below the ASX unmarketable parcel threshold
        (AUD $500).
      </>
    ),
    count: data?.unmarketable_shareholders,
    ringCount: data?.unmarketable_shareholders_pct,
    ringColor: '#2E7D32'
  }
]

export const SharesCards = (data: any) => [
  {
    name: 'Shares bought',
    desc: (
      <>
        Number of shares purchased during this period.
        <br />
        The change shown is relative to the previous period.
      </>
    ),
    count: data?.shares_bought,
    percentage: data?.shares_bought_percentage
  },
  {
    name: 'Shares sold',
    desc: (
      <>
        Number of shares sold during this period.
        <br />
        The change shown is relative to the previous period.
      </>
    ),
    count: data?.shares_sold,
    percentage: data?.shares_sold_percentage,
    invertColor: true
  }
]

export const InvestorCentreCards = (data: any) => [
  {
    name: 'Total visits',
    desc: (
      <>
        Total number of times the site was accessed, including repeat visits.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.total_visits,
    percentage: data?.total_page_change
  },
  {
    name: 'Unique visits',
    desc: (
      <>
        Number of distinct visitors during the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.unique_visits,
    percentage: data?.unique_visits_change
  },
  {
    name: 'Page views',
    desc: (
      <>
        Total number of pages viewed.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.page_views,
    percentage: data?.page_views_change
  }
]

export const ContentSectionCards = (data: any) => [
  {
    name: 'Announcements posted',
    desc: (
      <>
        Number of announcements published during the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.total_content,
    percentage: data?.total_content_change
  },
  {
    name: 'Average views per ann.',
    desc: (
      <>
        Average number of views per announcement in the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.average_views,
    percentage: data?.average_views_change
  },
  {
    name: 'Total views',
    desc: (
      <>
        Combined number of views across all announcements items in the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.total_view,
    percentage: data?.total_view_change
  },
  {
    name: 'Questions asked',
    desc: (
      <>
        Number of questions submitted during the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.total_questions,
    percentage: data?.total_questions_change
  }
]

export const EmailSectionCards = (data: any) => [
  {
    name: 'Emails sent',
    desc: (
      <>
        Total number of emails sent out in the period. The percentage shown is relative to the
        previous period.
      </>
    ),
    count: data?.emails_sent,
    percentage: data?.emails_sent_change
  },
  {
    name: 'Delivered Emails',
    desc: (
      <>
        Emails successfully accepted by recipient mail servers. The percentage shown is relative to
        the previous period.
      </>
    ),
    count: data?.delivered,
    percentage: data?.delivered_change
  },
  {
    name: 'Open Rate',
    desc: (
      <>
        Percentage of delivered emails that were opened at least once.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.open_rate,
    percentage: data?.open_rate_change,
    type: 'percent'
  },
  {
    name: 'Click Through Rate',
    desc: (
      <>
        Indicates how effectively an email motivates recipients to take action by clicking a link
        within the message.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.click_rate,
    percentage: data?.click_rate_change,
    type: 'percent'
  },
  {
    name: 'Total opens',
    desc: (
      <>
        Total number of open events (includes repeat opens by the same recipient).
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.opened,
    percentage: data?.opened_change
  },
  {
    name: 'Bounce rate',
    desc: (
      <>
        Percentage of sent emails that failed to deliver. The percentage shown is relative to the
        previous period.
      </>
    ),
    count: data?.bounced,
    percentage: data?.bounced_change,
    invertColor: true,
    type: 'percent'
  },
  {
    name: 'Unsubscribes',
    desc: (
      <>
        Number of recipients who unsubscribed from future emails during the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.unsubscribed,
    percentage: data?.unsubscribed_change,
    invertColor: true
  }
]

export const SocialSectionCards = (data: any) => [
  {
    name: 'Posts',
    desc: (
      <>
        Number of social posts published during the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.total_posts,
    percentage: data?.total_posts_change
  },
  {
    name: 'Average impressions',
    desc: (
      <>
        Average number of impressions per social post in the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.average_impressions,
    percentage: data?.average_impressions_change
  },
  {
    name: 'Total impressions',
    desc: (
      <>
        Combined number of impressions across all social posts in the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.total_impressions,
    percentage: data?.total_impressions_change
  }
]

export const QuestionSectionCards = (data: any) => [
  {
    name: 'Questions asked',
    desc: (
      <>
        Number of questions submitted during the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.total_questions,
    percentage: data?.total_questions_change
  },
  {
    name: 'Average response time',
    desc: (
      <>
        Average time taken to respond to questions during the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.avg_response_time_seconds,
    percentage: data?.avg_response_time_change
  },
  {
    name: 'Unanswered questions',
    desc: (
      <>
        Number of questions that remain unanswered during the selected period.
        <br />
        The percentage shown is relative to the previous period.
      </>
    ),
    count: data?.unanswered_questions,
    percentage: data?.unanswered_questions_change
  }
]
